export default __webpack_public_path__ + "static/media/LM.4de37037.png";